module.exports = __webpack_public_path__ + "img/2024SEA_avatar.52bde1bf.png";